import { render, staticRenderFns } from "./updateUserInfo.vue?vue&type=template&id=49748faf&scoped=true"
import script from "./updateUserInfo.vue?vue&type=script&lang=js"
export * from "./updateUserInfo.vue?vue&type=script&lang=js"
import style0 from "./updateUserInfo.vue?vue&type=style&index=0&id=49748faf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49748faf",
  null
  
)

export default component.exports